// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gH","advertCardNum":"c-a_gJ"};